export const MIN_COLUMN_WIDTH = 170;
export const MAX_COLUMN_WIDTH = 1170;
export const COLUMN_WIDTH_ATTRIBUTE = 'column-width';
export const SLUG = 'ws-column';
export const FLEX_BASIS_PROPERTY = 'flex-basis';
export const MAX_WIDTH_PROPERTY = 'max-width';
